export type EmailTemplateLanguageType = "en" | "gr";

export interface IEmailTemplateSubject {
  id: EmailTemplateSubjectEnum;
  labelEn: string;
  labelGr: string;
  alreadyInUse: boolean;
}

export enum EmailTemplateStatusEnum {
  Active,
  Inactive,
  Draft,
}

export interface ICreateOrUpdateEmailTemplate {
  subject: string;
  language: EmailTemplateLanguageType;
  status: EmailTemplateStatusEnum;
  content: string;
}

export interface IEmailTemplateForTable {
  id: string;
  subject: EmailTemplateSubjectEnum;
  languages: string[];
  status: EmailTemplateStatusEnum;
  lastEdited: string;
}

export interface IEmailTemplateVersion {
  id: string;
  content: string;
  language: EmailTemplateLanguageType;
  emailTemplateId: string;
  emailTemplate: IEmailTemplate;
}

export interface IEmailTemplate {
  id: string;
  subject: EmailTemplateSubjectEnum;
  status: EmailTemplateStatusEnum;
  emailTemplateVersions: IEmailTemplateVersion[];
}

export enum EmailTemplateSubjectEnum {
  BookingCancellation = "BookingCancellation",
  BookingReminder = "BookingReminder",
  BookingConfirmation = "BookingConfirmation",
  // MembershipCancellationConfirmation = "MembershipCancellationConfirmation",
  MembershipConfirmation = "MembershipConfirmation",
  WelcomeEmailAndGuide = "WelcomeEmailAndGuide",
  VerificationEmail = "VerificationEmail",
  ForgotPassword = "ForgotPassword",
  ChangePasswordConfirmation = "ChangePasswordConfirmation",
}
